import React, { useEffect, useRef, useState } from "react";
import NavItem from "./NavItem";
import { useOnClickOutside } from "@/src/hooks/use-on-click-outside";
import { Skeleton } from "../ui/skeleton";

const NavItems = ({
  category,
  categoryLoading,
}: {
  category: any;
  categoryLoading: boolean;
}) => {
  const [activeIndex, setActiveIndex] = useState<null | number>(null);

  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        setActiveIndex(null);
      }
    };

    document.addEventListener("keydown", handler);

    return () => {
      document.removeEventListener("keydown", handler);
    };
  }, []);

  const isAnyOpen = activeIndex !== null;

  const navRef = useRef<HTMLDivElement | null>(null);

  useOnClickOutside(navRef, () => setActiveIndex(null));

  return (
    <div
      className="hidden justify-center space-x-8 pt-5 text-sm font-semibold md:flex md:flex-wrap"
      ref={navRef}
    >
      {categoryLoading &&
        Array.from([1, 1, 1, , 1, 1, 1]).map((e: any, i: number) => (
          <Skeleton key={i} className="mb-3 h-8 w-1/12" />
        ))}

      {!categoryLoading &&
        category.map((item: any, i: number) => {
          const handleOpen = () => {
            if (activeIndex === i) {
              // setActiveIndex(null);
            } else {
              setActiveIndex(i);
            }
          };

          const close = () => setActiveIndex(null);

          const isOpen = i === activeIndex;

          return (
            <NavItem
              categoryItem={item}
              close={close}
              handleOpen={handleOpen}
              isOpen={isOpen}
              key={i}
              isAnyOpen={isAnyOpen}
            />
          );
        })}
    </div>
  );
};

export default NavItems;
